import React from 'react';

// Encabezado de las vistas sin vista previa (mismo estilo que la barra de PreviewSitio)
const BarraSeccion = ({ etiqueta, encabezado, ayuda, acciones }) => (
    <div className='preview_barra'>
        <div>
            <p className='preview_barra_etiqueta'>{etiqueta}</p>
            <p className='preview_barra_titulo'>{encabezado}</p>
            {ayuda && <p className='preview_barra_ayuda'>{ayuda}</p>}
        </div>
        {acciones && <div className='preview_barra_acciones'>{acciones}</div>}
    </div>
);

export default BarraSeccion;
